import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import { edit_profile_settings_path, subscribe_path } from '@routes';
import { ForumPostsResult } from '@utils/backend-api/forumPosts';
import { SubscriberDirectoryResponse } from '@utils/backend-api/subscriber_directory';

import SubscribersList from './SubscribersList';

type Props = {
  data?: ForumPostsResult | SubscriberDirectoryResponse;
};

const EmptyState = ({ message, href, cta }: { message: string; href: string; cta: string }) => (
  <div className="mt-24 flex flex-col items-center text-center text-grayscale-gray">
    <p className="font-suisse-intl text-subheadline-sm">{message}</p>
    <PrimaryButton className="mt-24" as="link" href={href}>
      {cta}
    </PrimaryButton>
  </div>
);

const DirectorySearchResults = ({ data }: Props) => {
  if (data.canViewDirectory) {
    return (
      <SubscribersList
        content={{
          profiles: data.profiles,
          currentUserId: data.currentUserId,
        }}
      />
    );
  }

  if (data.currentUserStatus > 0) {
    return (
      <EmptyState
        message="You must enable your profile to search the directory."
        href={edit_profile_settings_path()}
        cta="Go to profile settings"
      />
    );
  }

  return (
    <EmptyState
      message="You do not have access to view the directory. Subscribe to access."
      href={subscribe_path()}
      cta="Subscribe"
    />
  );
};

export default DirectorySearchResults;
